import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import {AssetService} from "../../services/AssetService";

export class ReportMaintenanceScheduleModel{
        static $inject = ['$q','FileSaver','Blob','$filter','AssetService','CustomFieldNameService','NotificationService'];
        errorMessage:string = "";
        search: string = "";
        locationName: string = "";
        locationSite: string = "";
        startDate:string = "";
        endDate:string = "";
        totalCount:number = 0;
        constructor(public $q:ng.IQService,
                    public fileSaver:any,
                    public blob:any,
                    public $filter:ng.IFilterService,
                    public assetService:AssetService,
                    public cfnService:CustomFieldNameService,
                    public notifyService:NotificationService) {
            this.getCount();
        }
        getReportName():String{
            return "Maintenance Schedule";
        }
        getReport():ng.IPromise<any>{
            var strStart = this.$filter('date')(this.startDate, "yyyy-MM-dd");
            var strEnd = this.$filter('date')(this.endDate, "yyyy-MM-dd");
            return this.assetService.getMaintenanceReport(this.search, this.locationName, this.locationSite, strStart, strEnd).then((data) => {
                var blob = new Blob([data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                this.fileSaver.saveAs(blob, 'scheduled_maintenance.xlsx');
            })
                .catch((exc)=>{
                    this.notifyService.notify("getReport err:"+exc);
                });
            return this.$q.when();
        }
        getCount():ng.IPromise<any>{
            //alert(this.location);
            var strStart = this.$filter('date')(this.startDate, "yyyy-MM-dd");
            var strEnd = this.$filter('date')(this.endDate, "yyyy-MM-dd");
            return this.assetService.getByMaintenanceCount(this.search, this.locationName, this.locationSite, strStart, strEnd)
                .then((data)=>{
                    this.totalCount = data;
                }).catch((exc)=>{
                    this.notifyService.notify("Exception in getCount-"+exc);
                });
        }
    }
